import React from 'react';
import type { FC, ReactNode } from 'react';

interface ChipProps {
    title: string;
    active?: boolean;
    leading?: ReactNode;
    trailing?: ReactNode;
    onClick?: () => void;
}

export const Chip: FC<ChipProps> = ({ title, leading, trailing, active, onClick }) => {
    return (
        <button
            type="button"
            className={`inline-flex items-center justify-center text-white ${active ? 'bg-blue-600' : 'bg-gray-100'} px-4 py-1.5 rounded-3xl text-xs font-light whitespace-nowrap`}
            onClick={onClick}
            onKeyUp={onClick}
        >
            {leading && <span>{leading}</span>}
            {leading && <div className="w-2" />}
            <span>{title}</span>
            {trailing && <div className="w-2" />}
            {trailing && <span>{trailing}</span>}
        </button>
    );
};
